import React, { useRef } from 'react'
import Button from '../Button'
import Icon, { IconType } from '../Icon'
import TooltipCentral from '../TooltipCentral'
import styles from '@bt-react/styles'
import componentStyles from './FileUploader.module.scss'
import { FormFeedback } from 'reactstrap'
import PropTypes from './types'
import classNames from 'classnames'

const FileUploader: React.FC<PropTypes> = ({isNarrowView, children, field, form, ...props}) => {

  const hiddenFileInput = useRef(null)
  const { reupload, id } = props

  const identifier = id ? id : 'select'

  const handleClick = event => {
    /*@ts-ignore*/
    hiddenFileInput.current.click()
  }
  const handleChange = event => {
    const fileUploaded = event.target.files[0]
    props.handleChange(fileUploaded)
  }
  return (
    <div className={classNames(componentStyles['file-uploder-container'], (props.className ? props.className : ''))} data-bdd="file-uploader">
        {reupload &&
            <span onClick={handleClick} className={componentStyles['reupload']}>
              <Icon name={IconType.iconName.uploadRegular} className={componentStyles['upload-icon']} />
              {!isNarrowView && <span className={componentStyles['reupload-text']}>Re-upload</span>}
            </span>
        }
        {!reupload && !children &&
          <Button 
              dataBdd="choose-file-button"
              onClick={handleClick}
              text="Choose file"
              color={IconType.colour.secondary}
              className={componentStyles['choose-btn']}
          />
        }
        { children && React.cloneElement( children, { onClick: handleClick } ) }
        <input type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{display:'none'}}
            accept={props.accept}
        />  
        {!reupload && !children &&     
          <span data-bdd="no-file-selected-label">
            No file selected
            <TooltipCentral placement={isNarrowView ? 'top' : 'right'} data-bdd="select-file-tooltip" content="Select that file from your computer that you wish to share with Audience members." id={`${identifier}-info-icon`}>
              <Icon dataBdd="select-file-tooltip-icon" name={IconType.iconName.infoCircle} className={componentStyles['info-icon']} id={`${identifier}-info-icon`} />
            </TooltipCentral>
          </span>
        }
        {form && form.touched && form.errors && form.touched[field.name] && form.errors[field.name] && <FormFeedback cssModule={styles} className={styles['d-block']}>{form.errors[field.name]}</FormFeedback>}
    </div>
  )
}
export default FileUploader